// Add your custom JS here.

document.addEventListener('DOMContentLoaded', () => {
    const body = document.body;
    const opening = document.getElementById('opening-mask');

    const startHeroAnimation = () => {
        const heroCopy = document.querySelector('.js-hero-copy');
        const heroWrap = document.querySelector('.hero-copy-wrap');

        if (!heroCopy || !heroWrap) return;

        setTimeout(() => {
            heroCopy.classList.add('is-active');
            heroWrap.classList.add('is-active');
        }, 400);
    };

    // opening-mask がないページでは普通に開始
    if (!opening) {
        body.classList.add('is-opening-finished');
        startHeroAnimation();
        return;
    }

    /*
    // 一度見た人には表示しない
    if (sessionStorage.getItem('openingPlayed') === 'true') {
        body.classList.add('is-opening-finished');
        startHeroAnimation();
        return;
    }
    */

    body.classList.add('is-opening');

    setTimeout(() => {
        body.classList.add('is-opening-start');
    }, 100);

    setTimeout(() => {
        body.classList.add('is-opening-end');
    }, 1700);

    setTimeout(() => {
        body.classList.remove('is-opening');
        body.classList.add('is-opening-finished');
        sessionStorage.setItem('openingPlayed', 'true');

        // オープニング終了後にHeroアニメ開始
        startHeroAnimation();

    }, 2200);
});


document.addEventListener('DOMContentLoaded', function () {
    const header = document.getElementById('main-nav');
    const isHome = document.body.classList.contains('home');

    if (!header) return;

    function getTriggerPoint() {
        return isHome ? window.innerHeight : 300;
    }

    function toggleHeaderClass() {
        const trigger = getTriggerPoint();

        if (window.scrollY > trigger) {
            header.classList.add('is-scrolled');
        } else {
            header.classList.remove('is-scrolled');
        }
    }

    window.addEventListener('scroll', toggleHeaderClass, { passive: true });
    window.addEventListener('resize', toggleHeaderClass);

    toggleHeaderClass();
});


jQuery(document).ready(function ($) {

    function isSamePageAnchorLink(link) {
        return (
            location.pathname.replace(/^\//, '') === link.pathname.replace(/^\//, '') &&
            location.hostname === link.hostname &&
            link.hash
        );
    }

    // 1. #navbarNavOffcanvas 内のアンカークリックでオフキャンバスを閉じる + スクロール
    $('#navbarNavOffcanvas a').click(function (e) {
        if (isSamePageAnchorLink(this)) {
            e.preventDefault();
            var target = $(this.hash);
            if (target.length) {
                $('html, body').animate({ scrollTop: target.offset().top }, 300);
                $('#navbarNavOffcanvas').offcanvas('hide');
            }
        }
    });

    // 2. それ以外のアンカーリンクに対するスムーズスクロール
    $('a').not('#navbarNavOffcanvas a').click(function (e) {
        if (isSamePageAnchorLink(this)) {
            e.preventDefault();
            var target = $(this.hash);
            if (target.length) {
                $('html, body').animate({ scrollTop: target.offset().top }, 300);
            }
        }
    });

});




document.addEventListener('DOMContentLoaded', () => {
    const worksSwiper = new Swiper('#works-swiper', {
        loop: true,
        speed: 700,
        centeredSlides: true,
        centerInsufficientSlides: true,
        slidesPerView: 1.2,
        spaceBetween: 16,
        grabCursor: true,

        effect: 'coverflow',
        coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 120,
            modifier: 1.2,
            scale: 0.6,
            slideShadows: false,
        },

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },

        breakpoints: {
            768: {
                slidesPerView: 2.2,
                spaceBetween: 24,
            },
            992: {

                slidesPerView: 3,
                spaceBetween: 30,
                loop: false, // ★追加
                centeredSlides: false // ★推奨
            }
        }
    });
});

